import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID, ViewChild, ElementRef, ChangeDetectorRef, AfterViewChecked, Renderer2, HostListener, ViewChildren, QueryList } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';
declare var $: any;
//services
import {StoreService} from 'src/app/services/store.service';
import {SharedService} from 'src/app/services/shared.service';
import {SEOService} from 'src/app/services/seo.service';
import {AnalyticsService} from 'src/app/services/analytics.service';
import { LoginService } from 'src/app/services/login.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { gsap } from 'gsap';
import { BusinessModeService } from 'src/app/services/business-mode.service';
import Swal from 'sweetalert2';
// import config file 
import { config } from 'src/app/config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @ViewChildren('menuList', { read: ElementRef }) menuLists!: QueryList<ElementRef>;
  isMenuOpen = false;
  isDiffHeadingClass: boolean = false;

  

  cartData: Observable<any>;
  data: Observable<any>;
  user: Observable<any>;
  totalItem: number;
  schedule: Observable<any>;
  selected_policy: any;

  toggleActive: boolean = false;
  isNavbarClicked = false;

  isLocationSelected: boolean = false;

  bsModalRef: BsModalRef;
  restaurantLocationsData: any;
  route_path: any;

  isBusinessDataModeOn = true;
  order_items: any = [];

  brand_socials: any = config?.brand_social_links;
  restaurant_socials: any;
  
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private storeService: StoreService,
    private sharedService: SharedService,
    private seoService: SEOService,
    private analyticsService: AnalyticsService,
    private loginService: LoginService,
    private renderer: Renderer2,
    public modalService: BsModalService,
    public businessModeService: BusinessModeService
  ) {
    /**RESTORE POLICY IN REDUX STORE UPON REFRESH**/
    this.storeService.storeExistingSelectedPolicy(); // restore existing selected policy
    this.storeService.storeExistingDeliveryTime(); // restore existing delivery time
    this.storeService.setExistingPaymentMethod(); // restore existing delivery time
    this.storeService.storeExistingCartData(); // restore existing cart data
    this.storeService.storeExistingAvailablePromotion(); // restore existing available promotion data
    this.storeService.storeExistingAcceptedPromotion(); // restore existing accepted promotion data
    this.storeService.storeExistingOrderNotes(); // restore existing accepted promotion data
    this.storeService.storeExistingLoyaltyReward(); // restore existing loyalty reward data
    this.storeService.storeExistingLoginData(); // restore existing accepted promotion data
    this.storeService.storeExistingResCartData(); // restore existing reservation cart data
    this.storeService.storeExistingResMenu(); // restore existing restaurant menu dish

    this.schedule = this.storeService.schedule;
    this.data = this.storeService.restaurantData;
    this.user = this.storeService.user;



    if (this.platformId === 'browser') {
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.route_path = event.url.replace('/', '');
        }
      });
    }

    /**CHECK RESTAURANT INFORMATION IN REDUX STORE THEN, GENERATE RESTAURANT SCHEDULE**/
    this.data.subscribe(result => {
      if (Object.getOwnPropertyNames(result).length !== 0) {
        if(result){
          this.isLocationSelected = true;
          this.isBusinessDataModeOn = false;

          this.restaurant_socials = result?.restaurant_data?.social_media;

          this.seoService.setPageTitle(result.restaurant_content.home_page.seo_page_title);// set page title
          this.seoService.addMetaTag(result.restaurant_content.home_page.seo_meta); // meta data
          this.analyticsService?.init(result?.restaurant_content?.home_page?.google_analytics);
          this.analyticsService.createSchema(result.restaurant_content.home_page.schema);
          this.seoService.createCustomContent(result.restaurant_content.home_page.custom_content);
        }
      }
    });
    /**END**/

    this.storeService.cartData.subscribe(value => {
        if (Object.getOwnPropertyNames(value).length !== 0) {
          this.order_items = value;
          this.sharedService.generateCartDataHashKey(value);
        } else {
          this.order_items = undefined;
        }
      });

  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isDiffHeadingClass = window.scrollY > 60;
  }

  ngOnInit() {
    this.businessModeService.businessMode$.subscribe(value => {
      this.isBusinessDataModeOn = value;
    });
  }

  // closeNavbar() {
  //   const navbarCollapse = document.getElementById('navbarSupportedContent');
  //   if (navbarCollapse && navbarCollapse.classList.contains('show')) {
  //     this.renderer.removeClass(navbarCollapse, 'show');
  //   }
  // }

  ngAfterViewInit() {
     
  }

  ngAfterViewChecked() {}

  navBarClicked(){
    // this.isNavbarClicked = !this.isNavbarClicked;
  }

  navigateUrl(){
    this.router.navigateByUrl("/home")
  }

  signOut() {
    if (this.platformId === 'browser') {
      document.body.classList.toggle('active-nav');
    }
    this.toggleMenu();
    this.loginService.logOut();
  }

  onHomePageClick() {
    if (this.platformId === 'browser') {
      this.router.navigateByUrl('/');
      this.businessModeService.setBusinessMode(true); 
    }
  }


    onOrderOnlineClickedForRouting(){
      this.restaurantLocationsData = JSON.parse(sessionStorage.getItem('restaurantLocationDatas'));
      this.sharedService.setLocationsData(this.restaurantLocationsData);

      if(this.isLocationSelected){
        this.router.navigateByUrl("/order-online")
        this.businessModeService.setBusinessMode(false);
      }else {
        this.router.navigateByUrl("/choose-location")
      }

    }
    onChoseLocationClickedForRouting(){
      this.restaurantLocationsData = JSON.parse(sessionStorage.getItem('restaurantLocationDatas'));
      this.sharedService.setLocationsData(this.restaurantLocationsData);
      // make a swal alert with yes no button if tes clicked route to choose location other wise just close the swal alert and keep user in same page
      // alert for: if you change your location your cart will be cleared 
      if(this.order_items?.length > 0){
        Swal.fire({
          title: 'Are you sure?',
          text: "If you change your location your cart will be cleared",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Okay, I understand',
          showCloseButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigateByUrl("/choose-location")
          }
        })
      }else {
        this.router.navigateByUrl("/choose-location")
      }
    }
    onChoseLocationClickedForRoutingWithToggle(){
      this.restaurantLocationsData = JSON.parse(sessionStorage.getItem('restaurantLocationDatas'));
      this.sharedService.setLocationsData(this.restaurantLocationsData);

      this.router.navigateByUrl("/choose-location")
      this.toggleMenu();
    }



    toggleAndChoseLocation(){
      this.restaurantLocationsData = JSON.parse(sessionStorage.getItem('restaurantLocationDatas'));
      this.sharedService.setLocationsData(this.restaurantLocationsData);
      this.toggleMenu();

      if(this.isLocationSelected){
        this.router.navigateByUrl("/order-online")
        this.businessModeService.setBusinessMode(false);
      } else {
        this.router.navigateByUrl("/choose-location")
      }
    }




    // NEW CODE START FROM HERE 

  toggleMenu() {
  this.isMenuOpen = !this.isMenuOpen; 

  const menu = this.menuLists.first?.nativeElement.querySelectorAll("li");
  const panel = document.querySelector(".custom-offcanvas") as HTMLElement;

  if (!menu || !panel) return;

  // Kill any previous tweens
  gsap.killTweensOf([menu, panel]);

  if (this.isMenuOpen) {
    // Reset panel before opening
    gsap.set(panel, { opacity: 0, pointerEvents: "auto" });
    gsap.set(menu, { y: 20, opacity: 0 });

    const tl = gsap.timeline();

    // Fade panel in
    tl.to(panel, {
      opacity: 1,
      duration: 0.5,
      ease: "power2.out"
    });

    // Stagger menu items
    tl.to(menu, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      stagger: 0.1,
      ease: "power2.out"
    }, "-=0.2");

  } else {
    const tl = gsap.timeline({
      onComplete: () => {
        // After closing, reset pointer events
        gsap.set(panel, { pointerEvents: "none" });
      }
    });

    // Stagger menu items out
    tl.to(menu, {
      y: 20,
      opacity: 0,
      duration: 0.3,
      stagger: 0.05,
      ease: "power2.in"
    });

    // Shrink panel
    tl.to(panel, {
      opacity: 0,
      duration: 0.5,
      ease: "power3.inOut"
    }, "-=0.2");
  }
}


}

